<mat-form-field>
    <mat-placeholder>
        {{label}}
    </mat-placeholder>

    <input #inputElement
           *ngIf="type !== 'textArea'"
           matInput
           autocomplete="off"
           [type]="inputType"
           [(ngModel)]="value"
           [disabled]="disabled"
           [igOnlyIntegerInput]="type === 'number'"
           [igOnlyFloatInput]="type === 'float'"
           [minValue]="minValue"
           [maxValue]="maxValue"
           [decimalPlaces]="decimalPlaces"
           [setValue]="setValue"
           (blur)="onBlur()"
           (keyup)="onKeyup($event)"
           (click)="onClick($event)"
           (ngModelChange)="modelChange()"
           [required]="isRequired"/>

    <textarea matInput
              *ngIf="type === 'textArea'"
              placeholder="Description"
              [disabled]="disabled"
              [(ngModel)]="command.description">
    </textarea>
</mat-form-field>

<mat-error *ngIf="!hideValidationMessages && isDirty && !!errorMessage">
    {{errorMessage}}
</mat-error>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/mat.field/mat.field.component.html